import type { FaireProductEntity } from "../../entity_types/product";

export const p_hv7a9g8psq: FaireProductEntity = {
  token: "p_hv7a9g8psq",
  type: "product",
  name: "Solid Color Cropped Sweatshirt & Straight Leg Pants Set",
  brandToken: "b_hrmradn4yd",
  brandName: "EmberLoom",
  imageUrl:
    "https://cdn.faire.com/fastly/d6723e844b27c9ec6e45a81a30bd019100d6ed8f94ef8c5059198c65eb895262.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/12fb1d627e0705525df2214b9eb32d53a2fb5ae548694fe77c0db9fa23cfb433.jpeg",
    "https://cdn.faire.com/fastly/3473c3c8c78c0c5a1eb39298598584a9426aaf2fcd56ffd15c24f7ee2c0c1873.jpeg",
    "https://cdn.faire.com/fastly/4fa0cf3cd9deab081ba88c7acf613c0e7d9911d6bc87014fbc188bf16fa5309b.jpeg",
    "https://cdn.faire.com/fastly/5c93651c0ac0592fa544e554a641dae8e817d6f359bdef063476c9b2cdca2844.jpeg",
    "https://cdn.faire.com/fastly/686b244e76094a154eaf6f9b56ae9d28e59383bddac4caefe2d9a8360854b09f.png",
  ],
  priceDollars: 23.69,
  description:
    "The Solid Color Cropped Sweatshirt & Straight Leg Pants Set by EmberLoom is designed for women who prioritize comfort and style. The cropped sweatshirt and straight-leg pants make it an ideal choice for lounging or casual outings. All designs are custom-made by Mrwolf, ensuring uniqueness and quality. Step into comfort with EmberLoom.\nCasual Solid Color Cropped Sweatshirt and Straight Leg Pants Set\nWeight: 450 grams. Main component: polyester fiber.",
  tags: [],
  msrpDollars: 47.38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:58.931Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
